module.exports = __webpack_public_path__ + "img/score5.42a0f776.png";